import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { num } from "@/lib/format";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { History } from "lucide-react";

const UP = { pz: "€/pz", kg: "€/kg", ml: "€/ml" };
const fmtData = (d) => (d ? d.slice(0, 10).split("-").reverse().join("/") : "—");

// Storico degli ultimi prezzi di acquisto di un articolo, per confrontare i fornitori
export function StoricoPrezziPopover({ articoloId, variante, fornitoreId, testid }) {
  const [open, setOpen] = useState(false);
  const { data: righe = [], isLoading } = useQuery({
    queryKey: ["mag-storico-prezzi", articoloId, variante || ""],
    queryFn: async () => (await api.get("/magazzino/articoli/storico-prezzi", { params: { articolo_id: articoloId, variante: variante || "" } })).data,
    enabled: open && !!articoloId,
  });
  const prezzi = righe.map((r) => r.costo_unitario);
  const min = prezzi.length ? Math.min(...prezzi) : null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={!articoloId} className="text-slate-400 hover:text-primary disabled:opacity-30 shrink-0" title="Storico prezzi di acquisto" data-testid={testid}><History className="h-4 w-4" /></button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[460px] p-0" data-testid={`${testid}-contenuto`}>
        <div className="px-3 py-2 border-b border-slate-100 text-sm font-semibold">Storico prezzi di acquisto</div>
        {isLoading ? <div className="p-3 text-sm text-slate-400">Caricamento…</div> : righe.length === 0 ? (
          <div className="p-3 text-sm text-slate-400" data-testid={`${testid}-vuoto`}>Nessun acquisto precedente per questo articolo.</div>
        ) : (
          <table className="w-full text-xs">
            <thead><tr className="text-left text-[10px] uppercase tracking-wider text-slate-400"><th className="px-3 py-1.5">Data</th><th className="px-3 py-1.5">Fornitore</th><th className="px-3 py-1.5">Doc.</th><th className="px-3 py-1.5 text-right">Q.tà</th><th className="px-3 py-1.5 text-right">Prezzo</th></tr></thead>
            <tbody>
              {righe.map((r, i) => (
                <tr key={i} className={`border-t border-slate-50 ${fornitoreId && r.fornitore_id === fornitoreId ? "bg-orange-50/60" : ""}`} data-testid={`${testid}-riga-${i}`}>
                  <td className="px-3 py-1.5 font-mono whitespace-nowrap">{fmtData(r.data)}</td>
                  <td className="px-3 py-1.5 truncate max-w-[160px]" title={r.fornitore_nome}>{r.fornitore_nome}</td>
                  <td className="px-3 py-1.5 text-slate-500 whitespace-nowrap">{r.tipo_documento === "fattura" ? "Fatt." : "DDT"} {r.ddt}</td>
                  <td className="px-3 py-1.5 text-right font-mono">{num(r.quantita, 2)}</td>
                  <td className={`px-3 py-1.5 text-right font-mono whitespace-nowrap ${r.costo_unitario === min ? "text-green-700 font-semibold" : ""}`}>{num(r.costo_unitario, 2)} {UP[r.unita_prezzo]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {righe.length > 0 && <div className="px-3 py-1.5 border-t border-slate-100 text-[11px] text-slate-500">In verde il prezzo più basso{fornitoreId ? " · evidenziate le righe del fornitore selezionato" : ""}.</div>}
      </PopoverContent>
    </Popover>
  );
}
